// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  align-items: flex-start;
  display: flex;
  width: 100%;
  .container {
    background: transparent;
    border: 2px solid #ffab00;
    border-radius: 8px;
  }
  .notification__image {
    height: 16px;
  }
  .heading-container {
    flex: 1;
  }
  .sub-heading {
    display: flex;
  }
  .take-action-link {
    padding: 0px ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    color: #000;
    cursor: pointer;
  }
`;

export default styles;
